import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiConnector, Table } from '@cureskin/api-client';

@Component({
  selector: 'operator-analysis-history',
  templateUrl: './operator-analysis-history.html',
  standalone: false,
})
export class OperatorAnalysisHistoryComponent {
  ticket: Table.SupportTicket;
  ticketHistory: Array<Table.SupportTicketHistory>;
  constructor(
    private dialogRef: MatDialogRef<OperatorAnalysisHistoryComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  async ngOnInit(): Promise<void> {
    this.ticket = this.data.ticket;
    this.ticketHistory = await ApiConnector.find(Table.SupportTicketHistory, {
      where: { supportTicket: this.ticket },
      include: ['createdBy'],
      descending: 'createdAt',
    });
  }

  formatKey(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }

  hideModal(): void {
    this.dialogRef.close();
  }
}
